import { apiClient } from "../config";

async function deletePollsAndSurvey(id: string) {
  const res = await apiClient.delete(`/admin/survey-and-polls/${id}`);
  return res.data;
}

export default deletePollsAndSurvey;
